export default __webpack_public_path__ + "static/media/module2-page.d15c0b0f.png";